import { PaymentType } from "types/business/PaymentType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = PaymentType[];

export const useDefaultObservablePaymentTypeArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectPaymentTypeArray extends BehaviorSubject<CurrentType> {}
